export enum InteractionType {
  /** Participant responded in dialog */
  DialogEstablishing = 1,
  /** Deal negotiation is completed */
  DealNegotiation = 2,
}
